module.exports = __webpack_public_path__ + "img/b011_1.90f74904.jpeg";